import React from 'react';

import { faBriefcase, faEllipsisVertical, faFaceSmile, faScissors } from '@fortawesome/pro-regular-svg-icons';

import { Button } from 'components/ui/button';
import { Popover, PopoverBody, PopoverContent, PopoverTrigger } from '@buildoutinc/blueprint-react/ui/Popover';

const PRESETS = [
  { icon: faBriefcase, instruction: 'Rewrite this to sound more formal.', label: 'More Formal' },
  { icon: faFaceSmile, instruction: 'Rewrite this to sound friendlier.', label: 'Friendlier' },
  { icon: faScissors, instruction: 'Rewrite this to be shorter.', label: 'Shorten' },
];

interface Props {
  onSelect: (instruction: string) => void;
}

// The common revisions, for when there is already text but the user hasn't described a change.
export function InstructionPresets({ onSelect }: Props) {
  return (
    <Popover>
      <PopoverTrigger
        render={<Button aria-label="Revise options" icon={faEllipsisVertical} size="sm" variant="ghost" />}
      />
      <PopoverContent align="end" side="top" style={{ width: 'max-content' }}>
        <PopoverBody className="d-flex flex-column gap-1 p-1">
          {PRESETS.map(preset => (
            <Button
              className="w-100 justify-content-start px-3"
              icon={preset.icon}
              key={preset.label}
              label={preset.label}
              size="sm"
              variant="ghost"
              onClick={() => onSelect(preset.instruction)}
            />
          ))}
        </PopoverBody>
      </PopoverContent>
    </Popover>
  );
}
